import PropTypes from 'prop-types'
import React, { Component } from 'react'

import ListItem from './ListItem'

export default class ReleaseTabDeactivated extends Component {

  static propTypes = {
    data: PropTypes.object
  }

  render() {
    const { data } = this.props
    const list = data.collection.filter((item) => item.isDeactivated)
      .sort((item1, item2) => {
        const date1 = new Date(item1.updatedAt).getTime()
        const date2 = new Date(item2.updatedAt).getTime()
        return date2 - date1
      })

    const key = (item) => (typeof item === 'string' ? item : item.id)

    return (
      <div>
        <h5>Deaktivierte Museen und Programme</h5>
        <ul className="nav-list deactivated-list vertical">
          {list.map((itm) => <ListItem key={key(itm)} item={itm} />)}
        </ul>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/release/components/TabDeactivated.js